<!-- File Drop Zone Component -->
<div class="file-drop-zone-container">
  <!-- Validation Errors -->
  @if (fileErrors().length > 0) {
    <div class="error-banner">
      <div class="error-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <div class="error-content">
        @for (error of fileErrors(); track error) {
          <div class="error-message">{{ error }}</div>
        }
      </div>
      <button type="button" class="close-btn" (click)="clearErrors()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  }

  <!-- Drop Zone Area -->
  <div
    class="drop-zone"
    [class.drag-over]="isDragOver()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    <div class="drop-zone-content">
      <div class="upload-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
      </div>

      <div class="drop-zone-text">
        <span class="primary-text">Drag and drop files here</span>
        <span class="secondary-text">or</span>
      </div>

      <div class="browse-button-container">
        <input
          #fileInput
          type="file"
          multiple
          accept=".txt"
          (change)="onFileSelected($event)"
          class="file-input" />
        <button
          type="button"
          class="btn btn-primary"
          (click)="openFilePicker($event)">
          Browse Files
        </button>
      </div>

      <div class="file-hint">
        Accepted: .txt files only &nbsp;·&nbsp; Max size:
        {{ maxFileSizeLabel }} per file &nbsp;·&nbsp; Max {{ maxFiles }} files
        per request
      </div>
    </div>
  </div>
</div>
